import { render, staticRenderFns } from "./asset-form.vue?vue&type=template&id=0bfe5379&scoped=true&"
import script from "./asset-form.vue?vue&type=script&lang=js&"
export * from "./asset-form.vue?vue&type=script&lang=js&"
import style0 from "./asset-form.vue?vue&type=style&index=0&id=0bfe5379&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfe5379",
  null
  
)

export default component.exports